import { Configuration, LogLevel } from "@azure/msal-browser";
import { settings } from "../utils/settings";

export const msalConfig: Configuration = {
    auth: {
        clientId: settings.VITE_AZURE_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${settings.VITE_AZURE_TENANT_ID}`,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Warning,
        },
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0,
    },
};

export const loginRequest = {
    scopes: [
        `https://AMHTAXAND.onmicrosoft.com/${settings.VITE_AZURE_CLIENT_ID}/access_as_user`,
        `https://AMHTAXAND.onmicrosoft.com/${settings.VITE_AZURE_CLIENT_ID}/offline_access`,
    ],
};

// Helper to know if we are in an iframe
export const isInIframe = (): boolean => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
